import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Loader from "./Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import toast from "react-hot-toast";
import { Dropdown } from "primereact/dropdown";
import ReportService from "../services/ReportService";
import WarehouseMasterService from "../services/WarehouseMasterService";
import { useBrand } from "../helper/BrandContext";

const DispatchDistributorReport = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const reportService = new ReportService();
  const warehouseMasterService = new WarehouseMasterService();
  const surveyLink = useRef(null);
  const [warehouses, setWarehouses] = useState([]);
  const [userType] = useState(sessionStorage.getItem("userType"));
  const [userWarehouse] = useState(sessionStorage.getItem("wareHouseId"));
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "packingDate",
    SortOrder: "DESC",
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: format(
      new Date(new Date().setDate(new Date().getDate() - 7)),
      "yyyy-MM-dd",
    ),
    ToDate: format(new Date(), "yyyy-MM-dd"),
    UserType: 0,
    brandId: 0,
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    ToDate: new Date(),
  });
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);

  const fetchWarehouseOptions = async () => {
    try {
      warehouseMasterService.GetWarehouseDDL().then((response) => {
        if (response) {
          let items = response.responseData;
          if (userType === "0") {
            let newItem = { label: "All", value: "0" };
            items.unshift(newItem);
            setWarehouses(items);
            setTableRequest((prevData) => ({
              ...prevData,
              WareHouseId: "0",
            }));
          } else {
            items = items.filter((item) => item.value === userWarehouse);
            setWarehouses(items);
            setTableRequest((prevData) => ({
              ...prevData,
              WareHouseId: items[0].value,
            }));
          }
        } else {
          toast.error(
            response.responseMessage || "Failed to fetch warehouse options",
          );
        }
      });
    } catch (error) {
      console.error("Failed to fetch warehouse options:", error);
      toast.error("Failed to fetch warehouse options");
    }
  };

  const DispatchDistributorReport = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    console.log("Request Body:", tableRequest);
    reportService
      .DistributorsDispatchReport(tableRequest)
      .then((response) => {
        console.log("API Response:", response);
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false,
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false,
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data: " + error.message);
        setState((prevData) => ({
          ...prevData,
          loading: false,
        }));
      });
  };

  const handleFormChange = (e) => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    setTableRequest((prevData) => ({
      ...prevData,
      WareHouseId: e.target.value,
    }));
    DispatchDistributorReport();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "FromDate" || name === "ToDate") {
      if (!value || !(value instanceof Date) || isNaN(value.getTime())) {
        toast.error(
          `Please select a valid ${name === "FromDate" ? "start" : "end"} date.`,
        );
        return;
      }
      if (name === "FromDate" && state.ToDate && value > state.ToDate) {
        toast.error("Start date must be before end date.");
        return;
      }
      if (name === "ToDate" && state.FromDate && value < state.FromDate) {
        toast.error("End date must be after start date.");
        return;
      }
    }
    setState((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const FilterData = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    tableRequest.FromDate = state.FromDate
      ? format(state.FromDate, "yyyy-MM-dd")
      : "";
    tableRequest.ToDate = state.ToDate
      ? format(state.ToDate, "yyyy-MM-dd")
      : "";
    DispatchDistributorReport();
  };

  const GetReportExport = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    tableRequest.PageSize = -1;
    reportService
      .PackingReport(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const filteredData = data.responseData.map(
            ({ totalRows, ...rest }) => rest,
          );
          setState((prevData) => ({
            ...prevData,
            allData: filteredData,
            loading: false,
          }));
          setTriggerDownload(true);
        } else {
          setState((prevData) => ({
            ...prevData,
            allData: [],
            loading: false,
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to export data");
      });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setTableRequest((prevData) => ({
      ...prevData,
      SearchValue: value,
    }));
    // Uncomment if real-time search is needed
    //PackingReport();
  };

  const onIndexTemplate = (data, props) => {
    return state.first + props.rowIndex + 1;
  };

  const dateBodyTemplate = (rowData, field) => {
    return rowData[field] && rowData[field] !== "1900-01-01T00:00:00"
      ? new Date(rowData[field]).toLocaleDateString()
      : "-";
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows,
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate
      ? format(state.FromDate, "yyyy-MM-dd")
      : "";
    tableRequest.ToDate = state.ToDate
      ? format(state.ToDate, "yyyy-MM-dd")
      : "";
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1,
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate
      ? format(state.FromDate, "yyyy-MM-dd")
      : "";
    tableRequest.ToDate = state.ToDate
      ? format(state.ToDate, "yyyy-MM-dd")
      : "";
    DispatchDistributorReport();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    getLazyLoadingValues(event);
    DispatchDistributorReport();
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    const date = new Date();
    date.setDate(date.getDate() - 7);
    setState((prevData) => ({
      ...prevData,
      FromDate: date,
      ToDate: new Date(),
      loading: false,
    }));
    setTableRequest((prevData) => ({
      ...prevData,
      FromDate: format(date, "yyyy-MM-dd"),
      ToDate: format(new Date(), "yyyy-MM-dd"),
    }));
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true,
    }));
    if (brand) {
      tableRequest.brandId = brand;
      fetchWarehouseOptions();
      DispatchDistributorReport();
    }
  }, [brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false);
    }
  }, [triggerDownload]);

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="date-picker-container flex items-center md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Dispatch Distributor Report
        </h1>
      </div>
      <div className="date-picker-container flex items-center md:mb-0">
        <Calendar
          value={state.FromDate || undefined}
          name="FromDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm mr-2"
        />
        <Calendar
          value={state.ToDate || undefined}
          name="ToDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm mr-2"
        />
        <Dropdown
          value={tableRequest.WareHouseId}
          onChange={handleFormChange}
          name="WareHouseId"
          options={warehouses}
          optionLabel="label"
          optionValue="value"
          filter
          placeholder="Select Plant/Warehouse"
          className="mr-2"
        />
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
        </div>
        <button
          type="button"
          onClick={FilterData}
          className="ml-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <button
          target="_blank"
          disabled={!state.sales.length}
          className="ml-3 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={GetReportExport}
        >
          Export
        </button>
        <CSVLink
          hidden={true}
          data={state.allData}
          ref={surveyLink}
          filename={"Dispatch Distributor Report.csv"}
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <DataTable
              scrollable
              exportFilename="Dispatch Distributor Report"
              responsive={true}
              header={header}
              globalFilter={state.globalFilter}
              emptyMessage={state.emptyMessage}
              value={state.sales}
              paginator={true}
              rows={state.rows}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rowsPerPageOptions={[10, 50, 200, 500]}
              totalRecords={state.totalRecords}
              lazy={true}
              first={state.first}
              onPage={onPage}
              onSort={onSort}
              className="p-datatable-responsive"
            >
              <Column
                field="seqNo"
                header="Seq No"
                style={{ width: "80px", "word-wrap": "break-word" }}
              />
              <Column
                field="skuName"
                header="Product SKU"
                sortable={false}
                style={{ width: "150px" }}
              />
              <Column
                field="batchNo"
                header="Batch No"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="mfgDate"
                header="MFG Date"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="expDate"
                header="EXP Date"
                sortable={false}
                style={{ width: "100px" }}
              />
              {/* <Column
                field="packingDate"
                header="Packing Date"
                sortable={true}
                style={{ width: "120px" }}
              />
              <Column
                field="cartonId"
                header="Carton ID"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchFromPlant"
                header="Dispatched From (Plant)"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchToWarehouse"
                header="Dispatched To (Plant)"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchDateFromPlant"
                header="Dispatch Date (Plant)"
                sortable={true}
                style={{ width: "120px" }}
              /> */}
              <Column
                field="isReceived"
                header="Received Status"
                sortable={false}
                style={{ width: "100px" }}
                body={(rowData) => (rowData.isReceived ? "Yes" : "No")}
              />
              <Column
                field="receivedLocation"
                header="Received Location"
                sortable={false}
                style={{ width: "200px" }}
              />
              <Column
                field="receiveDate"
                header="Receive Date"
                sortable={true}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchFromWarehouse"
                header="Dispatched From (Warehouse)"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchToDistributor"
                header="Dispatched To (Distributor)"
                sortable={false}
                style={{ width: "120px" }}
              />
              <Column
                field="dispatchDateFromWarehouse"
                header="Dispatch Date (Warehouse)"
                sortable={true}
                style={{ width: "120px" }}
              />
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default DispatchDistributorReport;
